var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Table } from '../../../components';
import { toDateTime } from '../../../helpers/Format';
var LogsList = /** @class */ (function (_super) {
    __extends(LogsList, _super);
    function LogsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.findUser = function (user_id) {
            var users = _this.props.store.users.users;
            return users.find(function (user) { return user.id === Number(user_id); });
        };
        _this.findTicket = function (id) {
            var tickets = _this.props.store.reports.tickets;
            return tickets.find(function (ticket) { return ticket.id === Number(id); });
        };
        return _this;
    }
    LogsList.prototype.componentDidMount = function () {
        this.props.store.logs.read();
        this.props.store.users.read();
        // const tickets = this.props.store.reports.readTickets()
    };
    LogsList.prototype.render = function () {
        var _this = this;
        var data = this.props.store.logs.data;
        var filtered = [];
        if (Array.isArray(this.props.entity)) {
            // filtro los que están en entity
            filtered = data.filter(function (log) { return _this.props.entity.filter(function (entity) { return entity === log.data.action; }).length > 0; });
        }
        else if (!Array.isArray(this.props.entity)) {
            filtered = data.filter(function (item) { return item.data.entity = _this.props.entity; });
        }
        var mapeados = filtered.map(function (item) {
            var temp = {
                id: item.id,
                action: item.data.action,
                date: toDateTime(item.date),
                type: Array.isArray(_this.props.entity) ? undefined : item.type,
                user: _this.findUser(item.user_id) ? _this.findUser(item.user_id).name : item.user_id,
                ticket: Array.isArray(_this.props.entity) ? undefined : (_this.findTicket(item.data.entity_id) ? _this.findTicket(item.data.entity_id).numero : item.data.entity_id)
            };
            return temp;
        });
        var header = ['date', 'user', 'action'];
        if (!Array.isArray(this.props.entity)) {
            header.push('type');
            header.push('ticket');
        }
        return (React.createElement(Table, { keyExtractor: function (item) { return String(item.id); }, items: mapeados, header: header, loading: !this.props.store.logs.loaded }));
    };
    LogsList = __decorate([
        inject('store'),
        observer
    ], LogsList);
    return LogsList;
}(Component));
export default LogsList;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Logs/containers/LogsList.tsx
// module id = 1260
// module chunks = 0